export const plural = (quantity = 1, singular: string, plural?: string) =>
  quantity === 1 ? 'singular' : plural ? plural : `${singular}s`;
